/** Persistencia de sesión BI en la pestaña (sobrevive refresh, no compartir entre pestañas). */

function sessionKey() {
  if (typeof window === 'undefined') return 'bi.auth.default';
  const parts = window.location.pathname.split('/').filter(Boolean);
  const tenant = parts[0] && parts[0] !== 'embed' ? parts[0] : 'default';
  return `bi.auth.${tenant}`;
}

export function saveAuthSession({ token, adminId, managerId, userId }) {
  if (typeof window === 'undefined' || !token) return;
  try {
    sessionStorage.setItem(
      sessionKey(),
      JSON.stringify({
        token: String(token),
        adminId: adminId != null ? String(adminId) : null,
        managerId: managerId != null ? String(managerId) : null,
        userId: userId != null ? String(userId) : null,
      })
    );
  } catch (_) {
    /* quota / private mode */
  }
}

export function loadAuthSession() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(sessionKey());
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function clearAuthSession() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(sessionKey());
  } catch (_) {
    /* ignore */
  }
}
